import HttpClient from "./http-client";

export interface IConnectionInfo {
  id?: string;
  connection_name: string;
  connection_description?: string;
  host_name: string;
  user_name: string;
  password?: string;
  port?: string;
  created_on?: string;
}

export default class ConnectionServices {
  /* private static async _createConnection(payload: IConnectionInfo) {
    const { data } = await HttpClient.post(`db/connection/`, payload);
    return data.data;
  } */

  public static async addConnection(payload: IConnectionInfo) {
    try {
      const { data } = await HttpClient.post(`db/connection/`, payload);
      if (data.status !== undefined)
        return {"status": data.status, "message": data.message};
      
      return data.data;
    } catch (error) {
      console.log(error);
    }
  }
  
  private static async retrieveConnections() {
    const { data } = await HttpClient.get(`db/connection/`);
    return data.data;
  }

  public static async getConnectionList() {
    return await ConnectionServices.retrieveConnections();
  }

}
